import BannerProjects from '../../components/bannerProjects'
import { Etapas } from '../../components/etapas'
import BannerSeguranca from '../../components/ia/banner-seguranca'
import Diferenciais from '../../components/ia/diferenciais'
import Rodape from '../../components/rodape'

export default function Ia() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-ia.png"
        bgMobile="../assets/cover-ia-mobile.png"
        title="/IA"
        iconSrc="../assets/icone-projectiva-nex2ai.png"
        iconAlt="Projectiva Nex2AI"
        iconText="omni"
        iconTextBold="core"
        descriptionBold=""
        description={
          <>
            Nossa abordagem em{' '}
            <strong className="font-inter-bold">Inteligência Artificial</strong>{' '}
            (IA) e Machine Learning (ML) foca em soluções seguras, eficientes e
            orientadas a{' '}
            <strong className="font-inter-bold">resultados de impacto</strong>{' '}
            para nossos clientes.
          </>
        }
        footerText="VERTICAL INNOVATION | Intelligence"
        buttonText="Quero me conectar"
        buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
        brand="nex2ai"
      />
      <Etapas />
      <Diferenciais />
      <BannerSeguranca />
      <Rodape />
    </>
  )
}
